import { Injectable } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { QuickSignUpModalComponent } from '../components/quick-sign-up-modal/quick-sign-up-modal.component';
import { SignupCaptureModalComponent } from '../components/signup-capture-modal/signup-capture-modal.component';
import { SessionService } from './session-service';
import { PendingFavourite } from './pending-favourite-service';

/** Optional wording for the sign-up form when it is opened for something specific (a Market Guide). */
export interface QuickSignupCopy {
  registerTitle?: string;
  registerText?: string;
  loginText?: string;
}

@Injectable({ providedIn: 'root' })
export class QuickSignupService {
  private hasShownInSession = false;

  constructor(
    private sessionService: SessionService,
    private dialog: MatDialog
  ) { }

  public signupCapture(force: boolean = false): void {
    if (this.hasShownInSession && !force) return;
    this.hasShownInSession = true;
    this.dialog.open(SignupCaptureModalComponent, {
      panelClass: 'no-padding',
    });
  }

  public quickSignup(
    reason: string,
    email: string | undefined,
    callback: (resp: boolean) => void,
    completeCallback: () => void,
    pendingAction?: PendingFavourite,
    startOn: 'login' | 'register' = 'login',
    copy?: QuickSignupCopy
  ): void {
    if (this.sessionService.isLoggedIn()) {
      callback(true);
      return; // were logged in
    }
    if (this.sessionService.requestingAccess) return; // dont open the modal multiple times
    this.sessionService.requestingAccess = true;
    var signupDialog = this.dialog.open(QuickSignUpModalComponent, {
      data: { reason: reason, email: email, pendingAction: pendingAction, startOn: startOn, copy: copy },
      // Viewport-safe on mobile: the panel never exceeds the screen in either
      // direction and scrolls internally (see .quick-signup-panel in
      // styles.scss). Desktop is unaffected (min() resolves to 408px).
      panelClass: 'quick-signup-panel',
      maxWidth: '100vw',
      width: 'min(408px, calc(100vw - 24px))',
      autoFocus: false,
    });
    signupDialog.afterClosed().subscribe((_: boolean) => {
      this.sessionService.requestingAccess = false; // reset to ensure access is requested after close
      if (_) {
        this.sessionService.EnterQueue(() => {
          completeCallback();
        });
        callback(_);
      }
    });
  }
}
